// Function to get routes with dynamic permissions based on reporting manager arrays



export const getRoutes = (reporting_manager_employees = [], reporting_manager_interns = []) => {
  // Determine permission based on reporting manager arrays
  const hasReportingEmployees = reporting_manager_employees?.length > 0;
  const hasReportingInterns = reporting_manager_interns?.length > 0;
  const shouldUseTeamTasks = hasReportingEmployees || hasReportingInterns;
  const taskPermission = shouldUseTeamTasks ? "VIEW_TEAM_TASKS" : "VIEW_ALL_TASKS";

  return [

    { name: "/", action: "PM_DASHBOARD" },

    { name: "/organization/switcher", action: "Switch_Organization" },
    { name: "/organization/switcher/", action: "Switch_Organization" },


    { name: "/organization/data-grid-settings", action: "ORGANIZATION_ALL||GRID_CONFIGRATION" },
    { name: "/organization/data-grid-settings/view", action: "ORGANIZATION_ALL||GRID_CONFIGRATION" },

    { name: "/organization/details", action: "ORGANIZATION_ALL||Switch_Organization" },
    { name: "/organization/details/add", action: "ORGANIZATION_ADD" },
    { name: "/organization/details/edit", action: "ORGANIZATION_EDIT" },
    { name: "/organization/profile", action: "ORGANIZATION_PROFILE_ALL" },
    { name: "/organization/entity", action: "ENTITY_ALL" },
    { name: "/organization/entity/add", action: "ENTITY_ADD" },
    { name: "/organization/entity/edit", action: "ENTITY_EDIT" },
    { name: "/organization/location", action: "LOCATION_ALL" },
    { name: "/organization/location/add", action: "LOCATION_ADD" },
    { name: "/organization/location/edit", action: "LOCATION_EDIT" },
    { name: "/organization/application-access", action: "VIEW_ORGANIZATION_APPLICATION||ORGANIZATION_ALL" },
    { name: "/organization/departments", action: "DEPARTMENT_ALL" },
    { name: "/organization/departments/add", action: "DEPARTMENT_ADD" },
    { name: "/organization/departments/edit", action: "DEPARTMENT_EDIT" },
    { name: "/organization/designation", action: "DESIGNATION_ALL" },
    { name: "/organization/designation/add", action: "DESIGNATION_ADD" },
    { name: "/organization/designation/edit", action: "DESIGNATION_EDIT" },
    { name: "/organization/work-shift", action: "SHIFT_VIEW_ALL" },
    { name: "/organization/work-shift/add", action: "SHIFT_ADD" },
    { name: "/organization/work-shift/edit", action: "SHIFT_EDIT" },

    { name: "/organization/employee/employee-details", action: "EMPLOYEE_VIEW_ALL" },
    { name: "/organization/employee/employee-details/add", action: "EMPLOYEE_ADD" },
    { name: "/organization/employee/employee-details/edit", action: "EMPLOYEE_EDIT" },
    { name: "/organization/employee/employee-exits", action: "EMPLOYEE_EXIT_VIEW_ALL" },
    { name: "/organization/employee/employee-exits/add", action: "EMPLOYEE_EXIT_ADD" },
    { name: "/organization/employee/employee-exits/edit", action: "EMPLOYEE_EXIT_EDIT" },

    { name: "/users", action: "USER_VIEW_ALL||USER_ALL" },
    { name: "/users/add", action: "USER_ADD" },
    { name: "/users/edit", action: "USER_EDIT" },
    { name: "/users/view", action: "USER_VIEW_ALL||USER_ALL" },
    { name: "/application/user-roles", action: "USER_ROLE_ALL" },
    { name: "/application/user-roles/add", action: "USER_ROLE_ADD" },
    { name: "/application/user-roles/edit", action: "USER_ROLE_EDIT" },
    {
      name: "/application/user-role-permission",
      action:
        "USER_ROLE_PERMISSION||USER_ROLE_PERMISSION_ALL||USER_ROLE_PERMISSION_ASSIGN||USER_ROLE_PERMISSION_REMOVE||USER_ROLE_PERMISSION_ADD||USER_ROLE_PERMISSION_EDIT||USER_ROLE_PERMISSION_DELETE",
    },
    { name: "/application/user-role-permission/add", action: "USER_ROLE_PERMISSION_ADD" },
    { name: "/application/user-role-permission/edit", action: "USER_ROLE_PERMISSION_EDIT" },
    {
      name: "/application/user-role-permission/view",
      action:
        "USER_ROLE_PERMISSION||USER_ROLE_PERMISSION_ALL||USER_ROLE_PERMISSION_ASSIGN||USER_ROLE_PERMISSION_REMOVE||USER_ROLE_PERMISSION_ADD||USER_ROLE_PERMISSION_EDIT||USER_ROLE_PERMISSION_DELETE",
    },
    {
      name: "/application/user-permission",
      action:
        "USER_PERMISSION_ALL||USER_PERMISSION_ADD||USER_PERMISSION_EDIT||USER_PERMISSION_DELETE",
    },
    { name: "/application/user-permission/add", action: "USER_PERMISSION_ADD" },
    { name: "/application/user-permission/edit", action: "USER_PERMISSION_EDIT" },
    { name: "/application/user-permission/view", action: "USER_PERMISSION_ALL||USER_PERMISSION_ADD||USER_PERMISSION_EDIT||USER_PERMISSION_DELETE" },

    { name: "/settings/change-password", action: "USER_RESET_PASSWORD" },


    { name: "/project-task", action: taskPermission },
    { name: "/project-task/add", action: "ADD_EMPLOYEE_TASK" },
    { name: "/project-task/edit", action: "EDIT_EMPLOYEE_TASK" },
    { name: "/project-task/view", action: taskPermission },



    { name: "/project-task/interns", action: taskPermission},
    { name: "/project-task/interns/add", action: "ADD_INTERN_TASK" },
    { name: "/project-task/interns/edit", action: "EDIT_INTERN_TASK" },
    { name: "/project-task/interns/view", action: taskPermission },


    { name: "/project-task-categories", action: "VIEW_TASK_CATEGORY" },
    { name: "/project-task-categories/add", action: "ADD_TASK_CATEGORY" },
    { name: "/project-task-categories/edit", action: "EDIT_TASK_CATEGORY" },
    { name: "/project-task-categories/view", action: "VIEW_TASK_CATEGORY" },



    { name: "/project-task-subcategories", action: "VIEW_TASK_SUBCATEGORIES" },
    { name: "/project-task-subcategories/add", action: "ADD_TASK_SUBCATEGORY" },
    { name: "/project-task-subcategories/edit", action: "EDIT_TASK_SUBCATEGORY" },
    { name: "/project-task-subcategories/view", action: "VIEW_TASK_SUBCATEGORIES" },

    { name: "/project-task-schedule", action: "VIEW_EMPLOYEE_TASK_SCHEDULE" },
    { name: "/project-task-schedule/add", action: "ADD_EMPLOYEE_TASK_SCHEDULE" },
    { name: "/project-task-schedule/edit", action: "EDIT_EMPLOYEE_TASK_SCHEDULE" },
    { name: "/project-task-schedule/view", action: "VIEW_EMPLOYEE_TASK_SCHEDULE" },

    // { name: "/organization-configration/business-registration-type", action: "" },

    { name: "/project-task-schedule/interns", action: "VIEW_INTERN_TASK_SCHEDULE", },
    { name: "/project-task-schedule/interns/add", action: "ADD_INTERN_TASK_SCHEDULE", },
    { name: "/project-task-schedule/interns/edit", action: "EDIT_INTERN_TASK_SCHEDULE", },
    { name: "/project-task-schedule/interns/view", action: "VIEW_INTERN_TASK_SCHEDULE", },



    { name: "/project-task-schedule-timelog", action: "VIEW_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/add", action: "ADD_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/edit", action: "EDIT_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/view", action: "VIEW_EMPLOYEE_TASK_SCHEDULE_TIMELOGS", },


    { name: "/project-task-schedule-timelog/interns", action: "VIEW_INTERN_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/interns/add", action: "ADD_INTERN_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/interns/view", action: "VIEW_INTERN_TASK_SCHEDULE_TIMELOGS", },
    { name: "/project-task-schedule-timelog/interns/edit", action: "EDIT_INTERN_TASK_SCHEDULE_TIMELOGS||EDIT_INTERN_TASK_SCHEDULE_TIEMLOGS", },

    // Client routes
    { name: "/client", action: "VIEW_ORGANIZATION_CLIENT||VIEW_ORGANIZATION_CLIENTS" },
    { name: "/client/add", action: "ADD_ORGANIZATION_CLIENT" },
    { name: "/client/edit", action: "EDIT_ORGANIZATION_CLIENT" },
    { name: "/client/view", action: "VIEW_ORGANIZATION_CLIENT||VIEW_ORGANIZATION_CLIENTS" },

    // Client Contact routes
    { name: "/client-contact", action: "VIEW_CLIENT_CONTACTS" },
    { name: "/client-contact/add", action: "ADD_CLIENT_CONTACT" },
    { name: "/client-contact/edit", action: "EDIT_CLIENT_CONTACT" },
    { name: "/client-contact/view", action: "VIEW_CLIENT_CONTACTS" },

    // Project routes
    { name: "/project", action: "VIEW_ORGANIZATION_PROJECT||VIEW_ORGANIZATON_PROJECTS||VIEW_ORGANIZATION_PROJECTS" },
    { name: "/project/add", action: "ADD_ORGANIZATION_PROJECT||ADD_ORGANIATION_PROJECT" },
    { name: "/project/edit", action: "EDIT_ORGANIZATION_PROJECT" },
    { name: "/project/detail", action: "VIEW_ORGANIZATION_PROJECT||VIEW_ORGANIZATON_PROJECTS||VIEW_ORGANIZATION_PROJECTS" },
    { name: "/project/view", action: "VIEW_ORGANIZATION_PROJECT||VIEW_ORGANIZATON_PROJECTS||VIEW_ORGANIZATION_PROJECTS" },

    // Project Type routes
    { name: "/project-type", action: "VIEW_PROJECT_TYPES||VIEW_PROJECT_TYPE" },
    { name: "/project-type/add", action: "PROJECT_TYPE_ADD" },
    { name: "/project-type/edit", action: "PROJECT_TYPE_EDIT" },
    { name: "/project-type/view", action: "VIEW_PROJECT_TYPES||VIEW_PROJECT_TYPE" },

    // Project Category routes
    { name: "/project-category", action: "VIEW_PROJECT_CATEGORY" },
    { name: "/project-category/add", action: "PROJECT_CATEGORY_ADD" },
    { name: "/project-category/edit", action: "PROJECT_CATEGORY_EDIT" },
    { name: "/project-category/view", action: "VIEW_PROJECT_CATEGORY" },

    // Project Sub Category routes
    { name: "/project-sub-category", action: "VIEW_PROJECT_SUBCATEGORIES||VIEW_PROJECT_SUBCATAGORY" },
    { name: "/project-sub-category/add", action: "PROJECT_SUBCATEGORY_ADD" },
    { name: "/project-sub-category/edit", action: "PROJECT_SUBCATEGORY_EDIT" },
    { name: "/project-sub-category/view", action: "VIEW_PROJECT_SUBCATEGORIES||VIEW_PROJECT_SUBCATAGORY" },

    // Project Templates routes
    { name: "/project-templates", action: "VIEW_PROJECT_TEMPLATES" },
    { name: "/project-templates/add", action: "PROJECT_TEMPLATE_ADD" },
    { name: "/project-templates/edit", action: "PROJECT_TEMPLATE_EDIT" },
    { name: "/project-templates/view", action: "VIEW_PROJECT_TEMPLATES" },

    // Project Templates Milestone routes
    { name: "/project-templates-milestone", action: "VIEW_TEMPLATE_MILESTONES" },
    { name: "/project-templates-milestone/add", action: "TEMPLATE_MILESTONE_ADD" },
    { name: "/project-templates-milestone/edit", action: "TEMPLATE_MILESTONE_EDIT" },
    { name: "/project-templates-milestone/view", action: "VIEW_TEMPLATE_MILESTONES" },

    // Project Template Tasks routes
    { name: "/project-template-tasks", action: "VIEW_TEMPLATE_TASK" },
    { name: "/project-template-tasks/add", action: "TEMPLATE_TASK_ADD" },
    { name: "/project-template-tasks/edit", action: "TEMPLATE_TASK_EDIT" },
    { name: "/project-template-tasks/view", action: "VIEW_TEMPLATE_TASK" },

    // Project Team routes
    { name: "/project-team", action: "VIEW_PROJECT_TEAMS" },
    { name: "/project-team/add", action: "ADD_PROJECT_TEAM" },
    { name: "/project-team/edit", action: "EDIT_PROJECT_TEAM" },
    { name: "/project-team/view", action: "VIEW_PROJECT_TEAMS" },

    // Project Team Member routes
    { name: "/project-team-member", action: "VIEW_PROJECT_TEAM_MEMBERS" },
    { name: "/project-team-member/add", action: "ADD_PROJECT_TEAM_MEMBER" },
    { name: "/project-team-member/edit", action: "EDIT_PROJECT_TEAM_MEMBER" },
    { name: "/project-team-member/view", action: "VIEW_PROJECT_TEAM_MEMBERS" },

    // Project Milestone routes
    { name: "/project-milestone", action: "VIEW_PROJECT_MILESTONES" },
    { name: "/project-milestone/add", action: "ADD_PROJECT_MILESTONE||ADD_PROJECT_MIESTONE" },
    { name: "/project-milestone/edit", action: "EDIT_PROJECT_MILESTONES" },
    { name: "/project-milestone/view", action: "VIEW_PROJECT_MILESTONES" },

    // Project Task Recurrence routes
    { name: "/project-task-recurrence", action: "VIEW_TASK_RECURRENCES" },
    { name: "/project-task-recurrence/add", action: "ADD_TASK_RECURRENCE" },
    { name: "/project-task-recurrence/edit", action: "EDIT_TASK_RECURRENCES" },
    { name: "/project-task-recurrence/view", action: "VIEW_TASK_RECURRENCES" },

    // Project Task Template routes
    { name: "/project-task-template", action: "VIEW_TASK_TEMPLATES" },
    { name: "/project-task-template/add", action: "ADD_TASK_TEMPLATE" },
    { name: "/project-task-template/view", action: "VIEW_TASK_TEMPLATES" },
    { name: "/project-task-template/edit", action: "EDIT_TASK_TEMPLATE" },

    // Project Task Type routes
    { name: "/project-task-type", action: "VIEW_TASK_TYPES" },
    { name: "/project-task-type/add", action: "ADD_TASK_TYPE" },
    { name: "/project-task-type/edit", action: "EDIT_TASK_TYPE" },
    { name: "/project-task-type/view", action: "VIEW_TASK_TYPES" },

    // My Profile route
    { name: "/my-profile", action: "VIEW_MY_PROFILE" },

    // Settings Update Credentials route
    { name: "/settings/update-credentials", action: "UPDATE_CREDENTIALS" },
  ];
};

// Default export for backward compatibility (uses empty arrays - defaults to VIEW_ALL_TASKS)
export let routes = getRoutes([], []);
